import { SEND_FOR_APPROVAL, SEND_FOR_APPROVAL_EMPTY, SEND_FOR_APPROVAL_ERROR, SEND_FOR_APPROVAL_SUCCESS } from '../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SendForApproval = (state = initialState, action) => {
  switch (action.type) {
    case SEND_FOR_APPROVAL:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SEND_FOR_APPROVAL_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SEND_FOR_APPROVAL_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SEND_FOR_APPROVAL_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SendForApproval;
